export default {
  namespaced: true,

  state: () => ({
    history: [],
    serverTime: new Date(),
    isEmployee: false,
    currentLevelName: null,
  }),

  getters: {
    isEmployee: (state) => state.isEmployee,
  },

  mutations: {
    setHistory(state, history) {
      state.history = history
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    setIsEmployee(state, isEmployee) {
      state.isEmployee = isEmployee;
    },
    setCurrentLevelName(state, currentLevelName) {
      state.currentLevelName = currentLevelName;
    },
  },

  actions: {
    async getLevel({ commit }) {
      const { curLevelCode, currentLevelName } = await this.$api.getLevel();

      commit('setIsEmployee', curLevelCode === 'employee');
      commit('setCurrentLevelName', currentLevelName);
    },

    async loadHistory({ commit }, { dateFrom, dateTo } = {}) {
      try {
        const result = await this.$api.loadBonusHistory({
          dateFrom,
          dateTo,
        });
        commit('setHistory', result);
      } catch (error) {
        commit('setHistory', []);
      }
    },
  },
};
